import { css } from 'emotion'

export const NewUserFormStyles = css`
  .TextInputField {
    margin-top: 32px;
  }
`
